// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tFMv0","content":"styles_content__fVKSo","image":"styles_image__TvNGt","texts":"styles_texts__yn9Ru","erid":"styles_erid__NpeGc"};